import { Component } from '@angular/core';
import { SessionService } from '@com-delta-idp/mnx-oauth';

@Component({
  selector: 'idp-profile-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(public session: SessionService) {}
}
